import { Component, inject, output } from '@angular/core';
import { IplpRecipeDetailObject } from '@libs/types/src/list/object-type/iplp-recipe.object';
import { ButtonComponent } from '../../../../kit/button/button.component';
import { FolderEPrescriptionMagistraliterRecipesStore } from './folder-e-prescription-magistraliter-recipes.store';

@Component({
    selector: 'app-folder-e-prescription-magistraliter-recipes',
    templateUrl: './folder-e-prescription-magistraliter-recipes.component.html',
    styleUrl: './folder-e-prescription-magistraliter-recipes.component.scss',
    providers: [FolderEPrescriptionMagistraliterRecipesStore],
    imports: [ButtonComponent],
})
export class FolderEPrescriptionMagistraliterRecipesComponent {
    protected readonly store = inject(FolderEPrescriptionMagistraliterRecipesStore);

    public readonly recipeSelected = output<IplpRecipeDetailObject>();

    protected open(): void {
        this.store.open(recipe => this.recipeSelected.emit(recipe));
    }
}
